module.exports = __webpack_public_path__ + "static/media/service.83cb4641.jpg";